export default __webpack_public_path__ + "static/media/flix.24b03f61.gif";